export enum CreationListMode {
  Regular,
  UnidentifiedPicker,
}
